














import CardOrderPenunjang from "@/components/pemeriksaan/penunjang/CardOrderPenunjang.vue";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    CardOrderPenunjang,
  },
})
export default class PenunjangMedisTabView extends Vue {
  @Prop() readonly register!: number;
  @Prop() readonly rm!: number;

  tab = "tab-soap";

  showTab(item) {
    this.tab = item;
  }
}
